import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import { MenuItem } from "../interfaces/menu-item.interface";
import { CSSVariable } from "../../../interfaces/css-variable.enum";
import { trackById } from "../../../utils/track-by";
import icPerson from "@iconify/icons-ic/twotone-person";
import icSettings from "@iconify/icons-ic/twotone-settings";
import icAccountCircle from "@iconify/icons-ic/twotone-account-circle";
import icMoveToInbox from "@iconify/icons-ic/twotone-move-to-inbox";
import icListAlt from "@iconify/icons-ic/twotone-list-alt";
import icTableChart from "@iconify/icons-ic/twotone-table-chart";
import icCheckCircle from "@iconify/icons-ic/twotone-check-circle";
import icAccessTime from "@iconify/icons-ic/twotone-access-time";
import icDoNotDisturb from "@iconify/icons-ic/twotone-do-not-disturb";
import icOfflineBolt from "@iconify/icons-ic/twotone-offline-bolt";
import icChevronRight from "@iconify/icons-ic/twotone-chevron-right";
import icArrowDropDown from "@iconify/icons-ic/twotone-arrow-drop-down";
import icBusiness from "@iconify/icons-ic/twotone-business";
import icVerifiedUser from "@iconify/icons-ic/twotone-verified-user";
import icLock from "@iconify/icons-ic/twotone-lock";
import icNotificationsOff from "@iconify/icons-ic/twotone-notifications-off";
import { Icon } from "@visurel/iconify-angular";
import { PopoverRef } from "../../popover/popover-ref";
import { GlobalCurrentUserService } from "src/app/pages/Services/global-current-user.service";
import { EvoGlobalService } from 'src/app/globals/evo-global.service';
import { Route } from '@angular/compiler/src/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/pages/Services/shared.service';
import { getSecureItem, setSecureItem } from 'src/app/pages/Services/secure-storage';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/pages/Services/language.service';
import { Observable } from 'rxjs';
import { HistoryService } from 'src/@evo/services/history.service';

export interface OnlineStatus {
  id: "online" | "away" | "dnd" | "offline";
  label: string;
  icon: Icon;
  color: CSSVariable;
}

@Component({
  selector: "nc-toolbar-user-dropdown",
  templateUrl: "./toolbar-user-dropdown.component.html",
  styleUrls: ["./toolbar-user-dropdown.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarUserDropdownComponent implements OnInit {
  currentUser: any;

  items: MenuItem[] = [
    {
      id: "1",
      icon: icAccountCircle,
      label: "Change Password",
      description: "Personal Information",
      color: CSSVariable["color-teal"],
      route: "/change-password",
    }
    // {
    //   id: "2",
    //   icon: icMoveToInbox,
    //   label: "My Inbox",
    //   description: "Messages & Latest News",
    //   color: CSSVariable["color-blue"],
    //   route: "/apps/chat",
    // },
    // {
    //   id: "3",
    //   icon: icListAlt,
    //   label: "My Projects",
    //   description: "Tasks & Active Projects",
    //   color: CSSVariable["color-amber"],
    //   route: "/apps/scrumboard",
    // },
    // {
    //   id: "4",
    //   icon: icTableChart,
    //   label: "Billing Information",
    //   description: "Pricing & Current Plan",
    //   color: CSSVariable["color-pink"],
    //   route: "/pages/pricing",
    // },
  ];

  statuses: OnlineStatus[] = [
    {
      id: "online",
      label: "Online",
      icon: icCheckCircle,
      color: CSSVariable["color-green"],
    },
    {
      id: "away",
      label: "Away",
      icon: icAccessTime,
      color: CSSVariable["color-orange"],
    },
    {
      id: "dnd",
      label: "Do not disturb",
      icon: icDoNotDisturb,
      color: CSSVariable["color-red"],
    },
    {
      id: "offline",
      label: "Offline",
      icon: icOfflineBolt,
      color: CSSVariable["color-teal"],
    },
  ];

  activeStatus: OnlineStatus = this.statuses[0];
  lang$: Observable<string>;

  trackById = trackById;
  icPerson = icPerson;
  icSettings = icSettings;
  icChevronRight = icChevronRight;
  icArrowDropDown = icArrowDropDown;
  icBusiness = icBusiness;
  icVerifiedUser = icVerifiedUser;
  icLock = icLock;
  icNotificationsOff = icNotificationsOff;

  constructor(
    private cd: ChangeDetectorRef,
    private globalCurrentUserService: GlobalCurrentUserService,
    private popoverRef: PopoverRef<ToolbarUserDropdownComponent>,
    private evoGlobalService:EvoGlobalService,
    private router: Router,
    private cookieService: CookieService,
    private sharedService: SharedService,
    public translate: TranslateService,
    private languageService: LanguageService,
    private historyService:HistoryService
  ) {
    this.lang$ = this.languageService.getLanguage();
  }

  ngOnInit() {
    this.lang$.subscribe(lang => {
      this.translate.use(lang['fileName'])
    });
    for(let item of this.items){
      this.translate.get([
          item.label,
          item.description
      ]).subscribe(translation => { 
          item.label = translation[item.label];
          item.description = translation[item.description];
      });
    }

    this.sharedService.getCurrentActiveUser().subscribe(result=>{
      if(result){
        this.currentUser = result;
      }else{
        this.currentUser = JSON.parse( this.globalCurrentUserService.getCurrentUser());
      }
    })
    
  }

  setStatus(status: OnlineStatus) {
    this.activeStatus = status;
    this.cd.markForCheck();
  }

  close() {
    this.historyService.clearHistory(); 
    
    this.currentUser = JSON.parse( this.globalCurrentUserService.getCurrentUser());
    if(!this.currentUser){
      this.popoverRef.close();
      this.router.navigate(["/login"]);
      if(localStorage.getItem("searchedData")){
        localStorage.removeItem("searchedData");
      }
      this.globalCurrentUserService.checkLoggedIn.next(false);
      return;
    }
    let body:any;
    this.evoGlobalService.logout(body).subscribe(result =>{
      //console.log("logout", result);      
        this.globalCurrentUserService.checkLoggedIn.next(false);
        let selectedLang = getSecureItem('selectedLang');
        localStorage.clear();
        setSecureItem('selectedLang',selectedLang);
        this.cookieService.deleteAll('/', null , true);
        this.popoverRef.close();
        if(localStorage.getItem("searchedData")){
          localStorage.removeItem("searchedData");
        }
        this.router.navigate(["/login"]);
        this.globalCurrentUserService.checkLoggedIn.next(false);      
    },error=>{
      this.popoverRef.close();
    });
  }

  changePass() {
    this.popoverRef.close();
  }
}
